{
  "adjectives": [
    "brave",
    "bouncy",
    "clever",
    "cosmic",
    "dizzy",
    "fuzzy",
    "gentle",
    "happy",
    "jolly",
    "lucky",
    "mighty",
    "nimble",
    "peppy",
    "plucky",
    "quick",
    "rapid",
    "shiny",
    "snappy",
    "sparkly",
    "speedy",
    "sunny",
    "swift",
    "turbo",
    "zippy"
  ],
  "animals": [
    "badger",
    "beaver",
    "bunny",
    "cheetah",
    "dolphin",
    "falcon",
    "ferret",
    "fox",
    "gecko",
    "hedgehog",
    "koala",
    "lemur",
    "lynx",
    "meerkat",
    "otter",
    "panda",
    "penguin",
    "puffin",
    "raccoon",
    "squirrel",
    "tiger",
    "turtle",
    "walrus",
    "wombat"
  ]
}
